import { combineReducers } from "redux";
import ui from "./ui";
import alert from "./alert";
import auth from "./auth";
import lang from "./lang";
import manageUsers from "./manageUsers";
import ksDept from "./ksDept";
import item from "./item";
import supplier from "./supplier";
import supplierContact from "./supplierContact";
import order from "./order";
import projectIdMapping from "./projectIdMapping";
import adminSettings from "./adminSettings";
import contract from './contract';
import supplierSuggestion from './supplierSuggestion'
import templateFile from './templateFile';
import loginFailedLog from './loginFailedLog';
import sharePointProcessedFile from './sharePointProcessedFile';
import emailTemplate from './emailTemplate';
import companyCode from './companyCode';

export default combineReducers({
  ui,
  alert,
  auth,
  lang,
  manageUsers,
  ksDept,
  item,
  supplier,
  supplierContact,
  order,
  projectIdMapping,
  adminSettings,
  contract,
  supplierSuggestion,
  templateFile,
  loginFailedLog,
  sharePointProcessedFile,
  emailTemplate,
  companyCode,
});
